import ACTION_TYPES from '../actions/action-types';
import { isTimeoutError } from '../submodules/shared/utils/handle-error';

export const TIMEOUT_NOTIFICATION_MESSAGE = 'Request timed out. Please check your connection and try again.';

export const notifyTimeout = (dispatch, error) => {
    if (!isTimeoutError(error)) {
        return false;
    }

    dispatch({
        type: ACTION_TYPES.SHOW_NOTIFICATION_MESSAGE,
        payload: { type: 'danger', message: TIMEOUT_NOTIFICATION_MESSAGE },
    });

    return true;
};
